//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import edit from './combineEdit';
import * as systemGroupDataApi from '@/api/systemGroupData.js';
import * as systemFormConfigApi from '@/api/systemFormConfig.js';
export default {
  // name: "combineDataList"
  components: {
    edit: edit
  },
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        gid: null,
        keywords: null,
        status: null,
        // 1=开启 2=关闭
        page: 1,
        pageSize: this.$constants.page.limit[0]
      },
      editDataConfig: {
        visible: false,
        isCreate: 0,
        // 0=create 1=edit
        editData: {}
      },
      formConf: {
        fields: []
      },
      dataList: {
        list: [],
        total: 0
      },
      formMark: 0
    };
  },
  mounted: function mounted() {
    this.handlerGetFormConfig();
    this.listPram.gid = this.formData.id;
    this.handlerGetListData(this.listPram);
  },
  methods: {
    handlerSearch: function handlerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData(pram) {
      var _this = this;
      // 获取列表数据
      systemGroupDataApi.groupDataList(pram).then(function (data) {
        var _selfList = [];
        data.list.forEach(function (_lItem) {
          _lItem.value = JSON.parse(_lItem.value);
          var _fields = _lItem.value.fields;
          var _rowData = {};
          _fields.map(function (item) {
            _rowData[item.name] = item.value;
          });
          _rowData.id = _lItem.id;
          _rowData.sort = _lItem.sort;
          _rowData.status = _lItem.status;
          _selfList.push(_rowData);
        });
        _this.dataList.list = _selfList;
        _this.dataList.total = data.total;
      });
    },
    handlerGetFormConfig: function handlerGetFormConfig() {
      var _this2 = this;
      // 获取表单配置后生成table列
      var _pram = {
        id: this.formData.formId
      };
      systemFormConfigApi.getFormConfigInfo(_pram).then(function (data) {
        _this2.formMark = parseInt(data.id);
        _this2.formConf = JSON.parse(data.content);
      });
    },
    handlerOpenEditData: function handlerOpenEditData(rowData, isCreate) {
      this.editDataConfig.editData = rowData;
      this.editDataConfig.isCreate = isCreate;
      this.editDataConfig.visible = true;
    },
    handlerHideDia: function handlerHideDia() {
      this.handlerGetListData(this.listPram);
      this.editDataConfig.visible = false;
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this3 = this;
      this.$confirm('确实删除当前数据', '提示').then(function () {
        systemGroupDataApi.groupDataDelete(rowData).then(function (data) {
          _this3.$message.success('删除数据成功');
          _this3.handlerHideDia();
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    }
  }
};